import { IRootState } from '../../../store'
import { ISignerState } from '../store/completeChart.types'

export const getSignersSelector = (state: IRootState): ISignerState => state.signerData
